function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "2BCF1CF6-1154-48EB-AF3E-A821CAD22C8E");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M2.1,12.2 C1.7143,12.2 1.4,11.8864 1.4,11.5 L1.4,5.0614 C1.6422,5.151 1.904,5.2 2.1749,5.2 L12.6,5.2 L12.6,6.6 L11.2,6.6 C10.3558,6.6 9.1,7.1593 9.1,8.7 C9.1,10.2407 10.3558,10.8 11.2,10.8 L12.6,10.8 L12.6,12.2 L2.1,12.2 Z M1.5666,2.6471 C1.6996,2.4903 1.8942,2.4 2.1,2.4 L11.2,2.4 L11.2,3.8 L2.1749,3.8 C1.799,3.8 1.463,3.5466 1.4098,3.2232 C1.3755,3.0104 1.4308,2.806 1.5666,2.6471 L1.5666,2.6471 Z M12.6,9.4 L11.2084,9.4 C10.885,9.3916 10.5,9.2642 10.5,8.7 C10.5,8.1358 10.885,8.0084 11.2,8 L12.6,8 L12.6,9.4 Z M13.3,3.8 L12.6,3.8 L12.6,1.7 C12.6,1.3129 12.2864,1 11.9,1 L2.1,1 C1.4833,1 0.9002,1.2695 0.4998,1.7399 C0.182,2.1137 0.0084,2.5834 0.0007,3.0692 C0,3.0797 0,3.0895 0,3.1 L0,11.5 C0,12.6578 0.9422,13.6 2.1,13.6 L13.3,13.6 C13.6864,13.6 14,13.2871 14,12.9 L14,4.5 C14,4.1129 13.6864,3.8 13.3,3.8 L13.3,3.8 Z",
  id: "path-2"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-systems",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Form-elements",
  transform: "translate(-630.000000, -786.000000)"
}, React.createElement("g", {
  id: "icon/balance",
  transform: "translate(630.000000, 785.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-2"
})), React.createElement("use", {
  id: "Mask",
  fill: "#42526E",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
}))));

var SvgBalanceIcon = function SvgBalanceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBalanceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/balance-icon.98c6c640.svg";
export { ForwardRef as ReactComponent };